module.exports = __webpack_public_path__ + "static/media/chaptersBackground.fd38db78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/chaptersBackground.jpg
// module id = 353
// module chunks = 0